export enum SLLoadingStatus {
  Idle = "Idle",
  Pending = "Pending",
  Resolved = "Resolved",
  Rejected = "Rejected"
}

export enum SLActionStatus {
  Enabled = "Enabled",
  Disabled = "Disabled",
  Removed = "Removed"
}

export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// We assume it is a string 20289 num
function concatSLWithDocumentNumberString(docNum: string): string {
  const prefix = "SL_";
  return `${prefix}${docNum}`;
}

export function leftPadDocumentNumber(aDocNum: string | number): string {
  if (typeof aDocNum === "number") {
    const docNum = `${aDocNum}`;
    return concatSLWithDocumentNumberString(docNum);
  } else {
    const docNum = aDocNum.trim();
    if (docNum === "") {
      return docNum;
    }
    if (docNum.startsWith("SL_")) {
      return docNum;
    } else {
      if (!isNaN(Number(docNum))) {
        return concatSLWithDocumentNumberString(docNum);
      } else {
        return docNum; // This is not a docNum whatever it is, leave it to the user to figure out
      }
    }
  }
}
